<script lang="ts">
    import { UsersRepository } from '../../../modules/usersApi/users/users.repository'
    import { UsersService } from '../../../modules/usersApi/users/users.service'
    import { get_current_component, onMount } from 'svelte/internal'
    import { User } from '../../../modules/usersApi/users/user'
    import type { UserUpdateDto } from '../../../modules/usersApi/users/dto/user-update.dto'
    import type { UserCreateDto } from '../../../modules/usersApi/users/dto/create-user.dto'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import Fa from 'svelte-fa'
    import { faPaperPlane, faAngleLeft, faClipboard, faCogs, faCopy, faEdit, faPercent, faPlusCircle, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    import { CompaniesRepository } from '../../../modules/usersApi/companies/companies.repository'
    import { CompaniesService } from '../../../modules/usersApi/companies/companies.service'
    import { Store } from '../../../modules/infra/store.service'
    import { UserPermissions } from '../../../modules/usersApi/users/dto/user-permissions.dto'
    import UserManagerPermissions from './user-manager-permissions.svelte'
    import UserComissions from './user-comissions.svelte'
    import Content from '../../_common/content.svelte'
    import { GridBadge, GridBadgeClassEnum, GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Zact from '../../_common/z/zact.svelte'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import ZContainer from '../../_common/z/z-container.svelte'
    import ZContainerCol from '../../_common/z/z-container-col.svelte'
    import { SendMessageTemplate } from '../../_common/send-message.template'
    import { AllowedHoursEntity } from '../../../modules/usersApi/companies/company'
    import { TagEntity } from '../../../modules/eventsApi/tags/tag.entity'
    const store = new Store()

    const usersRep = new UsersRepository()
    const usersS = new UsersService(usersRep)

    const compR = new CompaniesRepository()
    const compS = new CompaniesService(compR)

    const me = get_current_component()
    let show = false
    let step = 1
    let users: User[] = []
    let user: User = new User()
    let linkFieldContent = ''
    let linkField
    let linkHelpFieldContent = ''
    let linkHelpField

    let perms: UserPermissions = new UserPermissions()
    let allowLogin: boolean = true
    let allowedHours: AllowedHoursEntity

    onMount(async () => {
        try {
            show = true
            await loadUsers()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    })

    async function loadUsers() {
        try {
            show = true
            users = []
            users = await compS.getCompanyUsers()
            loadGrid()
            step = 1
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.showActs = true
        grid.title = 'Usuários da Empresa'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Nome' }))
        grid.cols.push(new GridCol({ content: 'ID' }))
        grid.cols.push(new GridCol({ content: 'Telefone', type: GridColTypeEnum.phone }))
        grid.cols.push(new GridCol({ content: 'E-Mail', type: GridColTypeEnum.email }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.badge }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of users) {
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.userName })
            line.slots.push({ content: item.userId })
            line.slots.push({ content: item.phone })
            line.slots.push({ content: item.email })
            let badges = []
            if (checkOwner(item.userId)) {
                badges.push(new GridBadge({ label: 'proprietário', class: GridBadgeClassEnum.badge_success }))
                //badges.push(new GridBadge({label: 'super', class:GridBadgeClassEnum.badge_success}))
            } else {
                badges.push(new GridBadge({ label: 'usuário', class: GridBadgeClassEnum.badge_default }))
            }
            if (checkLogged(item.userId)) {
                badges.push(new GridBadge({ label: 'você', class: GridBadgeClassEnum.badge_purple }))
            }
            line.slots.push({ content: badges })
            let disabled = !window.store.token.permissions.super || store.token.userId === item.userId // || store.company.owner === item.userId
            // mesma permissão da aba "Configurações" de Comissões e Salários; e ninguém edita a própria comissão
            // (mesmo motivo de não editar as próprias permissões — conflito de interesse), exceto o super usuário
            const comissionsSelfBlocked = store.token.userId === item.userId && !window.store.token.permissions.super
            const comissionsDisabled = !window.store.token.permissions.comissions?.configs?.write || comissionsSelfBlocked
            line.slots.push({
                content: [
                    new GridButton({
                        label: 'Permissões',
                        disabled,
                        icon: faCogs,
                        callback: () => {
                            editPerms(item.userId)
                        },
                    }),
                    new GridButton({
                        label: 'Comissões',
                        disabled: comissionsDisabled,
                        icon: faPercent,
                        callback: () => {
                            editComissions(item)
                        },
                    }),
                    new GridButton({
                        icon: faEdit,
                        label: 'Editar',
                        callback: () => {
                            editUser(item.userId)
                        },
                    }),
                ],
            })

            grid.lines.push(line)
        }
        grid = grid
    }

    async function editUser(userId: string) {
        try {
            show = true
            user = new User()
            user = await usersS.getOne(userId)
            console.log('user', user)
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function newUser() {
        user = new User()
        step = 2
    }

    let permsUserId: string
    async function editPerms(userId) {
        if (store.token.userId === userId) {
            evaluateError('Você não pode alterar suas próprias permissões')
            return
        }
        if (store.token.permissions?.super === false) {
            evaluateError('Você não pode acessar esta opção')
            return
        }
        selectedPermsUserId = userId
        const persisted = await usersS.getPermissions(userId)
        const allows = await window.api.users.companies.getAllowLogin(userId)
        allowLogin = allows?.allowLogin
        allowedHours = allows?.allowedHours || new AllowedHoursEntity()
        permsUserId = userId
        perms = persisted
        if (perms.super) {
            _changeToTrue(perms)
        }
        step = 5
    }

    // comissão personalizada por serviço (UserComissions cuida de carregar, editar e salvar)
    let comissionsUser: User = null
    function editComissions(target: User) {
        // o super usuário pode editar a própria comissão: é quem configura a empresa
        if (store.token.userId === target.userId && !window.store.token.permissions.super) {
            evaluateError('Você não pode alterar suas próprias comissões')
            return
        }
        if (!window.store.token.permissions.comissions?.configs?.write) {
            evaluateError('Você não pode acessar esta opção')
            return
        }
        comissionsUser = target
        step = 6
    }

    let selectedPermsUserId = ''
    async function savePermissions() {
        try {
            show = true
            console.log('p', Object.assign({}, perms))
            await window.api.users.companies.setAllowLogin(selectedPermsUserId, allowLogin, allowedHours)
            perms = await usersS.updatePermissions(selectedPermsUserId, perms)
            await loadUsers()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    $: {
        console.log('perms', perms)
    }

    function _changeToTrue(obj) {
        for (let prop in obj) {
            if (typeof obj[prop] === 'boolean') {
                obj[prop] = true
            } else {
                _changeToTrue(obj[prop])
            }
        }
    }

    async function saveUser() {
        if (user.userId) {
            updateUser()
        } else {
            createUser()
        }
    }

    async function createUser() {
        try {
            show = true
            const userDto: UserCreateDto = {
                allowAnonymous: user.allowAnonymous,
                allowTenant: user.allowTenant,
                email: user.email,
                phone: user.phone,
                userName: user.userName,
                userURL: user.userURL,
            }
            user = await usersS.create(userDto)
            await loadUsers()
            showToken()
        } catch (error) {
            if (error) {
                if (error.userId) {
                    await connectUser(error.userId)
                    return
                }
                if (error?.message && error.message.includes('userId:')) {
                    await connectUser(error.message.split(':')[1])
                    return
                }
            }
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function connectUser(userId: string) {
        if (!store.token.companyId) return null
        try {
            await compS.assignUser(store.token.companyId, userId)
            await loadUsers()
        } catch (error) {
            evaluateError(error)
        }
        //user = await usersS.getOne(userId)
    }

    async function updateUser() {
        try {
            show = true
            const userDto: UserUpdateDto = {
                allowAnonymous: user.allowAnonymous,
                allowTenant: user.allowTenant,
                email: user.email,
                phone: user.phone,
                userName: user.userName,
                userURL: user.userURL,
            }
            await usersS.update(user.userId, userDto)
            await loadUsers()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function removeUser() {
        if (!window.store.token.permissions.super) {
            window.error('Apenas super usuários podem excluir outro usuário')
            return
        }
        if (window.store.company.owner === user.userId) {
            window.error('O usuário proprietário/criador da empresa não pode ser excluído.')
            return
        }
        if (!confirm('Deseja mesmo excluir este usuário?')) {
            return
        }
        try {
            show = true
            //await usersS.remove(user.userId)
            if (!store.token.companyId) return null
            await compS.removeUser(store.token.companyId, user.userId)
            await loadUsers()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function showUsers() {
        step = 1
    }

    let linkPage = ''
    async function showToken() {
        if (!window.store.token.permissions.super) {
            window.error('Apenas um super usuário pode gerar links de login para terceiros.')
            return
        }
        try {
            show = true
            const token = await window.api.users.auth.requestLoginByToken(user.userId)
            linkPage = 'login?renew=1&token=' + token.token
            linkFieldContent = location.protocol + '//' + location.host + '/' + linkPage
            if (linkFieldContent.includes('support.')) {
                linkFieldContent = linkFieldContent.replace(/\/\/support./, '//pro.')
            }
            linkHelpFieldContent =
                'Link para criar senha:\n' +
                location.protocol +
                '//' +
                location.host +
                '/login?renew=1&token=' +
                token.token +
                '\n\n' +
                'Para acessar entre em https://pro.zandu.com.br\nUsuário: ' +
                user.phone +
                '\nSenha: [criada no link acima]'
            step = 3
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        if (error?.message) error = error.message
        if (error.startsWith('Only super users')) {
            window.error('Apenas super usuários podem adicionar novos usuários.')
            return
        }
        if (error.startsWith('User is already')) {
            window.error('O usuário informado já faz parte da empresa.')
            return
        }
        if (error.startsWith('There is another user with this phone number')) {
            window.error(`Já existe outro usuário usando este novo número de telefone.`)
            return
        }
        if (error.startsWith('You can not change')) {
            window.error(`Você não pode alterar o telefone de outro usuário.
            Apenas o próprio usuário pode alterar seu número de telefone.
            
            Caso este usuário não faça mais parte de sua empresa você pode excluir e adicionar outro.`)
            return
        }
        window.error(error)
    }

    function copyLink() {
        linkField.select()
        linkField.setSelectionRange(0, 99999) /* For mobile devices */
        window.api.utils.utils.copyToClipboard(linkField.value)
        window.alert('Link copiado')
    }

    function copyLinkHelp() {
        linkHelpField.select()
        linkHelpField.setSelectionRange(0, 99999) /* For mobile devices */
        window.api.utils.utils.copyToClipboard(linkHelpField.value)
        window.alert('Link copiado')
    }

    let permissionsCopied = null
    function copyPermissions() {
        permissionsCopied = JSON.parse(JSON.stringify(perms))
        console.log('perms copied', permissionsCopied)
    }
    function pastePermissions() {
        console.log('perms pasted', permissionsCopied)
        perms = JSON.parse(JSON.stringify(permissionsCopied))
        permissionsCopied = null
        perms = perms
    }

    function checkOwner(userId) {
        return userId === window.store.company.owner
    }

    function checkLogged(userId) {
        return userId === window.store.token.userId
    }
</script>

<Content footer={true}>
    {#if step === 1}
        <Zact>
            <div class="spacer" />
            {#if window.store.token.permissions.account.users.write}
                <Zbutton color="primary" icon={faPlusCircle} label="Novo usuário" mobileHideLabel={true} on:click={newUser} />
            {/if}
        </Zact>
        <Zgrid class="h-space" {grid}></Zgrid>
    {/if}
    {#if step === 2}
        <Zact>
            <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={showUsers} />
            <div class="spacer" />
            {#if window.store.token.permissions.account.users.write}
                {#if !!user.userId}
                    {#if store.token.userId !== user.userId}
                        <Zbutton color="red" icon={faTrashAlt} label="Excluir" disabled={show} on:click={removeUser} />
                    {/if}
                    <Zbutton color="secondary" icon={faPaperPlane} label="Link para login" on:click={showToken} />
                {/if}
                <Zbutton color="primary" icon={faSave} label="Concordar e salvar" loading={show} disabled={show} on:click={saveUser} />
            {/if}
        </Zact>
        <Zframe class="h-space" title="Dados do usuário">
            <ZContainer gapRow="8px" gapCol="8px">
                <Zinput size={5} sizeM={12} label="Nome" type="text" bind:value={user.userName} />
                <Zinput size={3} sizeM={12} label="Celular" type="tel" bind:value={user.phone} />
                <Zinput size={4} sizeM={12} label="E-Mail (opcional)" type="text" bind:value={user.email} />
                <ZContainerCol size={12}>
                    <div class="tos">
                        Ao criar um usuário <b>ele também</b> deverá concordar com nossos
                        <a target="_blank" href="/TOS.html">termos de uso.</a>
                    </div>
                </ZContainerCol>
            </ZContainer>
        </Zframe>
    {/if}
    {#if step === 3}
        <Zact>
            <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={showUsers} />
        </Zact>
        <Zframe class="h-space" title="Dados de acesso inicial">
            <div class="text-center">
                <p class="mt-3">
                    Através do link abaixo um usuário poderá acessar o Zandu e criar uma nova senha.
                    <br />O link é válido por 24 horas. Depois disso é necessário gerar um novo link.
                </p>
                <Zinput class="mb-3" rows={6} value={linkFieldContent} disabled={true} label="Link para criar senha" showCopy={true} type="textarea"></Zinput>
                <Zinput rows={11} value={linkHelpFieldContent} disabled={true} label="Link para criar senha com instruções" showCopy={true} type="textarea"
                ></Zinput>
            </div>
        </Zframe>
    {/if}
    {#if step === 5}
        <Zact>
            <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={showUsers} />
            <div class="spacer" />
            <Zbutton color="secondary" icon={faCopy} label="Copiar" on:click={copyPermissions} />
            <Zbutton color="secondary" icon={faClipboard} label="Colar" disabled={!permissionsCopied} on:click={pastePermissions} />
            {#if store.token.userId !== user.userId}
                <Zbutton color="primary" icon={faSave} label="Salvar" loading={show} disabled={show} on:click={savePermissions} />
            {/if}
        </Zact>

        <UserManagerPermissions permissions={perms} bind:allowLogin bind:allowedHours userId={permsUserId}></UserManagerPermissions>
    {/if}
    {#if step === 6 && comissionsUser}
        <UserComissions userId={comissionsUser.userId} userName={comissionsUser.userName} on:back={showUsers} />
    {/if}
</Content>
<LoadSpinner {show} />

<style>
    .tos a {
        text-decoration: underline;
    }
</style>
